<template>
  <BaseForm formColor="panel panel-primary" formIcon="fa fa-edit" formSubtitulo="Relatório de fornecedores"
            col-md="col-md-3" offset="offset-4">
    <template v-slot:inputForm>
      <form @submit.prevent="submitIncluirForm">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_inicio" v-model="dado.data_inicio" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataInicial" dateFormat="dd/mm/yyyy"/>
                <label for="data_inicio"><strong>Data inicial: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_fim" v-model="dado.data_fim" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataFim" dateFormat="dd/mm/yyyy"/>
                <label for="data_fim"><strong>Data final: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.status"
                    inputId="status"
                    :options="status"
                    optionLabel="label"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    :invalid="campoVazio.includes('status')"
                />
                <label for="status">
                  <strong>Status: <span class="text-danger font-bold">*</span></strong>
                </label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
        </div>
        <br>
      </form>
    </template>
  </BaseForm>
</template>

<script>

import {defineComponent} from "vue";
import BaseForm from "@/components/base/BaseForm.vue";
import {apiRequest, denormalizeDates} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default defineComponent({
  name: "RelatorioFornecedor",
  components: {
    BaseForm,
  },
  data() {
    return {
      dado: {
        data_inicio: null,
        data_fim: null,
        status: "T",
      },
      campoVazio: [],
      status: [
        {label: 'TODOS', value: 'T'},
        {label: 'ATIVO', value: 'A'},
        {label: 'INATIVO', value: 'I'}
      ],
    }
  },
  methods: {
    async submitIncluirForm() {
      denormalizeDates(this.dado, ['data_inicio', 'data_fim']);
      const resultado = await apiRequest("POST", apiUrl.fornecedores.relatorio, this.dado);
      if (resultado.success) {
        this.$router.push({
          path: '/relatorio',
          state: resultado.data
        });

      } else {
        this.$toastMessage("warn", "Atenção", resultado.error.detail);
        console.error("Erro:", resultado.error);
        this.campoVazio = Object.keys(resultado.error);
      }
    },
  },
  mounted() {
    Inputmask("99/99/9999").mask(this.$refs.dataInicial.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.dataFim.$el.querySelector("input"));
  },
})
</script>
